export default {"src":"/_next/static/media/brakes.b89a9927.svg","height":65,"width":60};